import { Button } from '@/shared/components/ui/button';
import { CustomLink } from '@/shared/components/ui/custom-link';

const NotFound = () => {
  return (
    <div className="$tw-flex $tw-h-full $tw-flex-1 $tw-flex-col $tw-items-center $tw-justify-center $tw-gap-4 $tw-bg-background $tw-text-foreground">
      <h2 className="$tw-font-semibold">Ha ocurrido un Error</h2>
      <p className="$tw-text-xl">El módulo al que está intentando acceder no existe.</p>
      <Button variant="secondary" className="$tw-text-foreground" asChild>
        <CustomLink to="/" replace>
          Volver a la página de inicio
        </CustomLink>
      </Button>
    </div>
  );
};

export default NotFound;
